import axios from 'axios'
import { ElMessage, ElLoading  } from 'element-plus'
import { BASE_URL } from "./config"
import storage from "../utils/storage"
let loadingInstance = null // 加载全局的loading
let loadingTimer = null // loading延迟显示定时器
let requestCount = 0 // 请求计数器
let loadingStartTime = null // loading开始显示的时间
const LOADING_DELAY = 300 // loading延迟显示时间（毫秒）
const MIN_LOADING_TIME = 200 // loading最小显示时间（毫秒）

const request = axios.create({ 
    baseURL: BASE_URL,
    // withCredentials: true,  // 表示跨域请求时是否需要使用凭证
    timeout: 60000, // 设置超时时间60s
})

// 显示loading（延迟显示）
const showLoading = () => {
    requestCount++
    // 如果已经有loading实例，不重复创建
    if (loadingInstance) {
        return
    }
    // 延迟显示loading，如果请求很快完成就不显示
    loadingTimer = setTimeout(() => {
        if (requestCount > 0 && !loadingInstance) {
            loadingInstance = ElLoading.service({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            loadingStartTime = Date.now()
        }
    }, LOADING_DELAY)
}

// 隐藏loading
const hideLoading = () => {
    requestCount--
    if (requestCount <= 0) {
        requestCount = 0
        // 清除延迟定时器（如果loading还没显示）
        if (loadingTimer) {
            clearTimeout(loadingTimer)
            loadingTimer = null
        }
        // 如果loading已经显示，延迟关闭（确保最小显示时间）
        if (loadingInstance) {
            const elapsed = loadingStartTime ? Date.now() - loadingStartTime : 0
            const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsed)
            setTimeout(() => {
                if (loadingInstance) {
                    loadingInstance.close()
                    loadingInstance = null
                    loadingStartTime = null
                }
            }, remainingTime)
        }
    }
}

/** 添加请求拦截器 **/
request.interceptors.request.use(config => {
    config.headers['content-type'] = "application/json;charset=UTF-8";
    config.headers['lang'] = storage.get('Language') && storage.get('Language') == 'en' ? storage.get('Language') : ''
    if(storage.get('token')){
        config.headers['user-token'] = storage.get('token')
    } 
    
    // 延迟显示loading
    showLoading()
    return config
}, error => {
    // 请求错误时也要隐藏loading
    hideLoading()
    return Promise.reject(error)
})


/** 添加响应拦截器  **/
request.interceptors.response.use(response => {
    hideLoading()
    if(response.data.code == 1){
        return Promise.resolve(response.data)
    } else if(response.data.code == 1000){
        return Promise.reject(response.data)
    } else{
        const status = response.data.code;
        switch (status) {
            case '-201' ||'-202' ||  '-203':
                ElMessage({
                    message: '登录过期，请重新登录！',
                    type: 'error'
                })

                storage.clear();

                setTimeout(() => { location.href = '/login' }, 1000);
                break;
            default:
                // ElMessage({
                //     message: response.data.msg,
                //     type: 'error'
                // })
                return Promise.reject(response.data)
        }
    }  
}, error => {
    hideLoading()
    if (error && error.response) {
        const status = error.response.status;
        switch (status) {
            case 404:
                ElMessage({
                    message: '请求的资源不存在',
                    type: 'error'
                })
                break;
            case 500:
                ElMessage({
                    message: '服务器请求出错！',
                    type: 'error'
                })
                break;
            default:
                ElMessage({
                    message: '其他错误',
                    type: 'error'
                })
        }
    } else {
        ElMessage({
            message: '请求失败',
            type: 'error'
        })
    }
    return Promise.reject(error)
})

export const get = (url, params) => {
    return request({
        url,
        method: 'get',
        params
    })
}

export const post = (url, params) => {
    return request({
        url,
        method: 'post',
        data: params
    })
}
